import { headerHeight, sidebarCollapsedWidth, sidebarWidth as sidebarDefaultWidth, sidebarTransitionDuration, sidebarTransitionTimingFunction, } from './constants';
import { styled } from '@/core/ui';
import gpPatternPath from '@/shared/assets/GpPattern50.svg?url';
import gpDarkPatternPath from '@/shared/assets/GpPattern900.svg?url';
export const BackgroundBox = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    // minHeight:"100%"
    minHeight: '100vh',
    //background: "url(./public/adm/GPPatternSVG.svg) right bottom no-repeat, url(./public/adm/GPPatternSVG.svg) left top repeat"
    backgroundImage: `url(${gpPatternPath}), url(${gpPatternPath})`, // 'first, second'
    backgroundRepeat: 'repeat-y',
    backgroundPosition: 'top -40px right 80px, top -40px right 180px;', // 'first, second'
    backgroundSize: '90px 79px',
    // 	//filter: 'blur(5px)',
    ...(theme.palette.mode === 'dark' && {
        backgroundImage: `url(${gpDarkPatternPath}), url(${gpDarkPatternPath})`, // 'first, second'
    }),
}));
export const ContentBox = styled('div', {
    shouldForwardProp: (prop) => prop !== 'sidebarCollapsed' && prop !== 'sidebarWidth',
})(({ sidebarCollapsed, sidebarWidth }) => ({
    display: 'flex',
    flex: '1 auto',
    flexDirection: 'column',
    paddingTop: headerHeight,
    paddingLeft: sidebarCollapsed ? sidebarCollapsedWidth : (sidebarWidth ?? sidebarDefaultWidth),
    transitionProperty: 'padding,width',
    transitionDuration: sidebarTransitionDuration,
    transitionTimingFunction: sidebarTransitionTimingFunction,
}));
export const Main = styled('main', {
    shouldForwardProp: (prop) => prop !== 'sidebarCollapsed',
})(({ theme, sidebarCollapsed }) => ({
    display: 'flex',
    flex: '1 auto',
    flexDirection: 'column',
    padding: sidebarCollapsed ? '.5rem .5rem .5rem 0' : '.5rem .5rem .5rem 0',
    // Moves footer out of the screen. Warehouse tables need to be full height to not waste place.
    minHeight: '100vh',
    // Prevents Main's box shadow from being overlapped by sidebar's background.
    zIndex: theme.zIndex.fab,
}));
